// event buses
export const rewatchDemoDayPitchKey = Symbol();

// action cable
export const auctionChannelKey = 'DemoDayPack::AuctionChannel';
export const demoDayStreamingChannelKey = 'DemoDayPack::DemoDayStreamingChannel';
